<template>
  <div class="rising-sign-container">
    <div class="mx-auto w-full max-w-[1100px] min-h-screen pb-12 pt-4">
      <!-- masthead -->
      <AdController unit="masthead" />

      <!-- content -->
      <div class="w-full flex mt-6 max-w-[1100px]">
        <!-- body -->
        <div class="text-white w-full max-w-[717px]">
          <div class="px-4 sm:px-0">
            <ArticleBreadcrumb />
            <h1 v-if="!isResultPage" class="text-24 sm:text-28 font-bold text-white tracking-tight leading-snug mt-8">
              Yükselen Burç Hesaplama
            </h1>
            <h1
              v-if="isResultPage && risingSignData && risingSignData.horoscope"
              class="text-24 sm:text-48 font-bold text-white tracking-tight leading-snug my-3"
            >
              Yükselen Burcun: {{ risingSignData.horoscope.name }}
            </h1>
            <AstrologyArticleAuthor :authors="article.authors" :class="{ 'mt-8': !isResultPage, 'mb-4': isResultPage }" />
            <div v-if="!isResultPage" class="text-24 font-normal mt-6">Şimdi Bilgilerini Alalım</div>
            <div v-if="!isResultPage" class="text-md font-normal mt-4 mb-3">
              Yükselen burcunu öğrenmek için doğum tarihini, saatini ve yerini paylaşmanı istiyoruz. Bu bilgilerle, senin için en uygun
              astrolojik bilgileri sunabiliriz!
            </div>
            <RisingSignForm />
            <div v-if="isResultPage" class="mt-4">
              <!-- image -->
              <div class="w-[175px] h-[275px] mx-auto sm:mx-0 m-4 sm:mr-8 bg-[#F7F2DA] rounded-2xl overflow-hidden sm:float-left">
                <OImage
                  :src="`https://static-onedio.s3.eu-west-1.amazonaws.com/astroloji/${risingSignData.horoscope.slug}.png`"
                  class="w-full h-full"
                />
              </div>
              <!-- entries -->
              <div class="text-md mt-4 sm:p-4 sm:pl-0">
                <div v-for="entry in risingSignData.entries" :key="entry.id">
                  <div class="text-28 font-bold">{{ entry.title }}</div>
                  <div class="text-lg">{{ entry.description }}</div>
                </div>
              </div>
            </div>
            <div v-if="!isResultPage" class="text-24 font-normal mt-6">Yükselen Burç nedir?</div>
            <div v-if="!isResultPage" class="text-md font-normal mt-4 mb-3">
              Yükselen burç, doğduğunuz anda doğu ufkundan yükselen burçtur. Doğum haritasını bir saat gibi düşünürsek, doğum anındaki saat
              ve dakikada ufukta hangi burç yükseliyorsa, işte o senin yükselen burcundur. Kişiliğiniz, dış görünüşünüz ve başkalarının sizi
              nasıl algıladığı üzerindeki etkisi büyüktür. Bu yüzden yükselen burç, astrolojide çok önemlidir ve sadece Güneş burcunuz kadar
              sizi anlatır. Hatta bazı ebeveynler, bebeklerinin yükseleni için doğum saatini bile planlar. Geleceği de şekillendirdiğine
              inanılan yükselen burçların cinsiyetlere göre farklı özellikler gösterdiği de biliniyor. Peki burçlara göre yükselenler nasıl
              farklılıklar gösteriyor?
            </div>
            <div v-if="!isResultPage" class="text-24 font-normal mt-6">Yükselen Burç Neyi İfade Eder?</div>
            <p v-if="!isResultPage" class="text-md font-normal mt-4 mb-3">
              Astrolojide “yükselen burç”, doğduğunuz anda doğu ufkunda yükselmekte olan burçtur. Doğum haritasındaki yükselen burç, kişinin
              hayata başlangıç enerjisini temsil eder.
              <br />
              <br />
              Güneş burcu, bir insanın içsel kimliğini, karakterinin temelini anlatırken yükselen burç, dış dünyaya nasıl göründüğümüzü ve
              çevremizle ilk temas kurduğumuz alanı belirler. Yani bir anlamda, insanların sizinle ilk karşılaştığında algıladığı “siz”,
              çoğunlukla Güneş burcunuz değil, yükselen burcunuzdur. Bu nedenle sosyal ilişkilerde, imajda, hatta fiziksel duruşta dahi
              yükselen burcun etkisi fazlasıyla hissedilir.
              <br />
              <br />
              Bazı astrologlara göre yükselen burç, zamanla kişinin karakterine daha çok yerleşir ve yıllar geçtikçe Güneş burcuyla birlikte
              belirginleşmeye başlar. Bu nedenle astrolojik analizlerde yükselen burç, en az Güneş burcu kadar önemlidir.
            </p>
            <div v-if="!isResultPage" class="text-24 font-normal mt-6">Yükselen Burç Nasıl Hesaplanır?</div>
            <p v-if="!isResultPage" class="text-md font-normal mt-4 mb-3">
              Yükselen burcunuzu öğrenebilmek için doğduğunuz tarih ve yer bilgilerine ek olarak doğum saatinizin de kesin olarak bilinmesi
              gerekir. Çünkü yükselen burç, her yaklaşık iki saatte bir değişir. Ufuk çizgisine hangi burcun denk geldiği, Dünya’nın
              dönüşüne bağlı olarak sürekli değiştiği için birkaç dakikalık sapmalar bile doğum haritasında ciddi farklar yaratabilir.
              <br />
              <br />
              Eğer doğum saatiniz netse çeşitli astroloji siteleri ve uygulamaları üzerinden doğum haritanızı çıkarabilir ve yükselen
              burcunuzu kolaylıkla öğrenebilirsiniz. Ancak doğum saatiniz net değilse, bu durumda “doğum saati rektifikasyonu” adı verilen
              yöntemle geçmişte yaşadığınız önemli olaylara göre bir saat aralığı tespit edilmeye çalışılır.
            </p>
          </div>

          <OImage
            v-if="!isResultPage"
            src="https://srv-cdn.onedio.com/store/f609b91834324a201cd106ad1c8935f49c5e45b43527c86dcc0972beb66eeda2.png"
            class="w-full h-auto sm:w-[715px] sm:h-[375px] mt-4 px-4 sm:px-0 object-cover"
          />

          <OArticle :item="article" :hide="['meta', 'breadcrumb', 'tags', 'kunye', 'author', 'entries', 'title']" />
          <!-- frequency widget cards -->
          <AstrologyWidgetCard />
          <TarotTypesSwiper class="sm:hidden px-4 mt-6" />
        </div>
        <!-- aside -->
        <aside class="text-white hidden sm:block sm:w-[344px] sm:ml-9">
          <AdController unit="newSidebarSponTop" class="bg-[#f7f8fb] p-6 sticky z-1 top-24 xmt-8" />
          <AstrologyPopularCard />
          <!-- other tarot types -->
          <div class="sticky z-1 pt-4 top-[400px] bg-black">
            <TarotTypesSwiper />
          </div>
        </aside>
      </div>
    </div>

    <!-- astrology CTA -->
    <div v-if="isResultPage" class="sm:h-[400px] w-full bg-[#080C25] u-center py-6 sm:py-16 px-4 sm:px-0">
      <div class="mx-auto w-full max-w-[1100px] u-center">
        <AstrologyCTA horoscope-name="Koç" horoscope="aries" type="love" frequency="daily" />
      </div>
    </div>

    <!-- kunye -->
    <div class="h-[176px] sm:h-52 w-full bg-black u-center px-4 sm:px-0">
      <div class="mx-auto w-full max-w-[1100px] u-center">
        <AstrologyArticleAuthor :authors="article.authors" is-kunye />
      </div>
    </div>

    <!-- reactions and comments -->
    <div class="w-full bg-[#101116] u-center">
      <div class="mx-auto w-full max-w-[1100px]">
        <LazyHydrate :when-visible="{ rootMargin: '100px' }">
          <OArticleReactions class="mt-10 mb-6" :item="article"></OArticleReactions>
        </LazyHydrate>
        <LazyHydrate :when-visible="{ rootMargin: '300px' }">
          <OArticleComments :id="'reactions-' + article.legacyId" class="mb-10" :item="article"></OArticleComments>
        </LazyHydrate>
      </div>
    </div>

    <!-- more info tarot -->
    <TarotMoreInfoCard v-if="false" />
  </div>
</template>

<script>
import { defineComponent, useRoute } from '@nuxtjs/composition-api';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout';
import OArticle from '@/modules/article/components/OArticle.vue';
import ArticleBreadcrumb from '@/modules/article/components/ArticleBreadcrumb';
import AdController from '@/modules/ads/components/AdController';
import LazyHydrate from 'vue-lazy-hydration';
import TarotTypesSwiper from '@/modules/tarot/components/TarotTypesSwiper.vue';
import TarotMoreInfoCard from '@/modules/tarot/components/TarotMoreInfoCard.vue';
import AstrologyArticleAuthor from '@/modules/astrology/components/AstrologyArticleAuthor.vue';
import AstrologyPopularCard from '@/modules/astrology/components/AstrologyPopularCard.vue';
import AstrologyWidgetCard from '@/modules/astrology/components/AstrologyWidgetCard.vue';
import AstrologyCTA from '@/modules/astrology/components/AstrologyCTA.vue';
import OArticleComments from '@/modules/article/components/OArticleComments.vue';
import OArticleReactions from '@/modules/article/components/OArticleReactions.vue';
import RisingSignForm from '@/modules/astrology/components/RisingSignForm.vue';
import { OImage } from '@/modules/common/components/ui';

export default defineComponent({
  components: {
    ErrorPageLayout,
    OArticle,
    OArticleReactions,
    OArticleComments,
    ArticleBreadcrumb,
    AstrologyArticleAuthor,
    AstrologyPopularCard,
    AstrologyWidgetCard,
    AstrologyCTA,
    LazyHydrate,
    AdController,
    TarotTypesSwiper,
    TarotMoreInfoCard,
    RisingSignForm,
    OImage,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    risingSignData: {
      type: Object,
    },
  },
  setup() {
    const route = useRoute();
    const isResultPage = route.value.path.includes('/sonuc');
    return { isResultPage };
  },
});
</script>

<style lang="scss">
@import '~/assets/css/custom-article.scss';
.rising-sign-container {
  background: linear-gradient(180deg, #2e2270 0%, #000 12%);
}
</style>
